import { useIsMutating } from '@tanstack/react-query';

export const ADMIN_IMAGE_TEMPLATE_UPDATE_MUTATION_KEY = ['admin/imageTemplates/<templateId>/update'];

// Reads the update from the mutation cache, so it survives the form that started it unmounting.
export function useIsAdminImageTemplateUpdating() {
	return useIsMutating({ mutationKey: ADMIN_IMAGE_TEMPLATE_UPDATE_MUTATION_KEY }) > 0;
}
